(function ($, Global) {
    var urlParams = new UrlParams();
    var FormLoginComponent = function(model) {
        this.model = model;
    }

	FormLoginComponent.prototype.initEvents = function() {
        this.publishers();
    }

	FormLoginComponent.prototype.publishers = function() {
        var self = this;

        $(document).on('submit', '.form-login', function(e) {
            e.preventDefault();
            var params = urlParams.getParams();
            var $this = $(this);
            var data = $this.serializeJson();
            var $form = $this.closest('form');

            data['Identifiant'] = data['Identifiant'].replace(/\s/g, '');

            self.handleLoader($this, $form)            

            if (params['lnkpmc']) {
                data['lnkpmc'] = params['lnkpmc'];
            }

            self.model.login(data, $form, function(result) {
                self.handleLogin(result, $form)                
            })
        })
    }

    FormLoginComponent.prototype.handleLoader = function ($this,$form) {
        if (!$('.landing-box').hasClass('loading')) {
            $.Topic('loader-show').publish('.landing-box');
        }
        if ($this.closest('.menutop').exists()) {
            $.Topic('loader-show').publish('.menutop .form-login');
        }

        if ($form.closest('.modal-content').exists()) {
            $.Topic('loader-show').publish($form.closest('.modal-content'));
        }
    }

    FormLoginComponent.prototype.handleLogin = function (result, $form) {
        var $this = $(this);
        var data = $this.serializeJson();

        if (result.data.html) {
            if ($form.closest('.modal-body').exists()) {
                return $form.closest('.modal-body').html(result.data.html);
            }
            if (!result.data.complete) {
                $('.landing a').remove();
                return $('#landing').html(result.data.html);
            }
        } else if (result.data.token) {
            var ssoModel = new SsoModel();
            return ssoModel.indigoLogin(result.data.token, true);
        } else if (data['Redirect']) {
            return Global.location.replace(data['Redirect']);
        }
        Global.location.reload(true);
    }

	Global.FormLoginComponent = FormLoginComponent;
}(jQuery, window));